import clsx from 'clsx'
import PropTypes from 'prop-types'

import { AppBar, Tabs, Box, useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { ReactComponent as CaretDown } from '../../../assets/icons/caret-down.svg'

import * as CTTPropTypes from '../../../common/propTypes'
import Step from '../../../ui/components/step'

import useStyles from './styles'

// TODO: check a11y
const Stepper = ({ children, steps, states, currentStep, onClickStep }) => {
  const classes = useStyles()
  const theme = useTheme()
  const isXl = useMediaQuery(theme.breakpoints.up('xl'))

  const handleChange = (_, newCurrentStep) => {
    onClickStep(newCurrentStep)
  }

  return (
    <Box>
      <AppBar position="static" className={classes.appBar}>
        <Tabs
          className={classes.tabs}
          value={currentStep}
          onChange={handleChange}
          variant={isXl ? 'fullWidth' : 'scrollable'}
          scrollButtons="auto"
          ScrollButtonComponent={({ className, ...props }) => (
            <Box className={clsx(className, classes.scrollButtons)} {...props}>
              <CaretDown />
            </Box>
          )}
        >
          {Object.entries(steps).map(([name, { title, subtitle }], index) => (
            <Step
              key={name}
              name={name}
              value={name}
              title={title}
              subtitle={subtitle}
              index={index}
              status={states[name]}
            />
          ))}
        </Tabs>
      </AppBar>
      {children}
    </Box>
  )
}

Stepper.STATUS = Step.STATUS

Stepper.propTypes = {
  children: PropTypes.node,
  steps: PropTypes.object.isRequired,
  ...CTTPropTypes.stepper,
}

export default Stepper
